export default __webpack_public_path__ + "static/media/61.638ff3d8.png";